import { RegisterMethod } from '@pflegia/types/common/enums/register-method.enum';
import { transformedEventProperties } from '@pflegia/ui/application/marketing/tracking/utils/transformed-event-properties';

import { trackEventRegistration } from '@shared/application/tracking/track-registration';

export const REGISTER_BUTTON_EVENT_NAME = 'signup_clicked';

export enum RegisterButtonTrackingIds {
  LandingPageTopNavigationId = '1',
  JobBoardId = '2',
  LandingPageRightBottomCornerId = '3',
  LandingPagePermanentCardId = '4',
  LandingPageFlexibleCardId = '5',
  LandingPageHowItWorks = '6',
  BlogHowItWorks = '7',
  LandingPageElderlyCare = '8',
  LandingPageNursing = '9',
  LandingPageMedicalStaff = '10',
  LandingPageOther = '11',
  LoginInPageSignUpButtonId = '12',
}

// TODO: Refactor https://pflegia.atlassian.net/browse/PFLG-7318
export const signupButtonClickTrackEventRegistration = (
  buttonId: RegisterButtonTrackingIds,
  registerMethod: RegisterMethod,
  sortedBy?: string,
) =>
  trackEventRegistration(
    REGISTER_BUTTON_EVENT_NAME,
    registerMethod,
    // eslint-disable-next-line eslint-compat/camelcase
    transformedEventProperties(sortedBy ? { buttonId, sorted_by: sortedBy } : { buttonId }),
  );
